// 🚨 **THE INDEX TABLES DO NOT USE DataTables Responsive, AND THIS FILE EXISTS SO NOBODY TURNS IT BACK
// ON.** Owner decision 2026-10-26: *"need to revert since users didn't like it"* — at laptop width the
// tables were hiding columns behind an expand arrow, and the people using them want every column with a
// sideways scroll instead.
//
// 📌 **Measured before reverting, on the 13-column customers index** — columns hidden behind the arrow:
// 1920 → 1, 1536 → 2, **1440 → 3, 1366 → 3**, 1280 → 4, 1100 → 5. A quarter of the table on an ordinary
// laptop.
//
// 🔑 **`F-123` was NOT the cause and reverting it was NOT the fix — check this before blaming a commit.**
// `"responsive": true` had been set since `7021c2a2`, **2021-12-02**; all `F-123` changed was where the
// expander lived (`details.type` from the implicit `'inline'` to a control `'column'`), because inline put
// the arrow in the record's own first cell and tapping it opened the record. So reverting `F-123` would
// have recovered about ONE column of the four and reintroduced that tap-target bug. What went was
// Responsive itself, in all three layers: the pack option, the view `<th>` and the datatable's
// `view_columns` entry.
//
// ⚠️ **The known cost, accepted with the decision**: on a phone the customers index is now a ~1700px
// sideways scroll. That is what "every column, always" means on a 13-column table, and it is why
// Responsive was there in the first place.
// 📌 The scroll itself is NOT `scrollX: true` — DataTables' own scroller splits the header and body into
// two tables that must be kept width-synced, and it would have swallowed the toolbar that
// `src/datatableChrome.js` relocates. One `overflow-x: auto` wrapper around the `<table>` does the same
// job with no machinery; that wrapper is applied in `datatableChrome.js`.

// 🚨 **An EXPLICIT sort, kept from `F-123`, and the index changed back to 0 with the control column.**
// DataTables' own default is `aaSorting: [[0, 'asc']]` (`jquery.dataTables.js:10285`), so this is now the
// same as the default — it stays explicit because the `F-123` failure was a silent one: a non-orderable
// column at index 0 made the request carry `order[0][column]=0`, `_fnSortFlatten` does not filter on
// `bSortable`, `ajax-datatables-rails` adds a clause only `if column.orderable?`, and the resulting
// `order(Arel.sql(''))` is dropped by Rails 8.1's `compact_blank`.
// ⚠️ **The lost alphabetical default was the visible half; the unstable paging was the dangerous one** —
// server-side `LIMIT/OFFSET` with no ORDER BY can repeat or skip rows between pages.
// 📌 A factory, not a shared array: `_fnExtend` is called at init without `breakRefs`
// (`jquery.dataTables.js:974`), so `settings.aaSorting` **is** the array passed in, and `_fnSortListener`
// mutates it in place (`:6265-6277`). A module-level array leaks across pages, because webpack evaluates a
// module once and Turbolinks keeps the JS context — measured: sorting customers by column 9 then opening
// the 5-column contract people table rendered **0 rows**.
export const orderFirstDataColumn = () => [[0, 'asc']]

// 🔑 **TODO.md F-169. The sort column resolved from a CLASS, because `order` is the one DataTables option
// that cannot take one.** `_fnSortFlatten` (`jquery.dataTables.js:5961`) consumes `[idx, dir]` only, so
// every other reference to a column here is by class and this one has to be a number.
// 🚨 **The number has now moved three times** — `targets: [5]` → `[6]` when `F-123` inserted a control
// column, back to `[5]` when `F-168` removed it, and the customers table's sort from `[0]` to `[1]` when
// `F-169` put the id first. Each move was silent: the wrong index sorts by the wrong column, and for a
// column some roles cannot see, by an invisible one they cannot click away.
// 📌 Reading the server-rendered `<thead>` is what makes it derived: the headers are in the DOM before
// `.DataTable()` runs, so this resolves once at init with no ordering requirement.
// ⚠️ Falls back to 0 if the class is absent, which would silently sort by the first column —
// `spec/config/datatable_responsive_spec.rb` asserts the `<th>` carries it, so the fallback is a
// last resort rather than the contract.
export const orderByColumnClass = (tableId, className) => {
  const headers = Array.from(document.querySelectorAll(`#${tableId} thead th`))
  const index = headers.findIndex((th) => th.classList.contains(className))

  return [[index < 0 ? 0 : index, 'asc']]
}
